import React, { useState } from "react";
import { FaEnvelope,FaWhatsapp } from 'react-icons/fa';
import "./Contact.css";
import fb from "./fb.png";
import wb from "./wb.png";
import ib from "./ib.png";
import yb from "./yb.png";
import Navbar from "./Navbar";
const Contact = () => {
  const [name1, setName1] = useState("");
  const [name2, setName2] = useState("");
  const [message, setMessage] = useState("");

  const whatsappNumber = "+923222999888"; // Replace with owner's WhatsApp number

  const handleSubmit = (e) => {
    e.preventDefault();
    const textMessage = `Assalam o Alaikum, my name is ${name1} ${name2}. ${message}`;
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      textMessage
    )}`;
    window.open(whatsappUrl, "_blank");
  };
  return (
    <>
      <Navbar isHome={false} />
      
      <section>
      <div className="contact-us-section d-flex justify-content-center align-items-center text-white">

        {/* Overlay */}
        <div className="overlay"></div>

        {/* Contact Content */}
        <div className="contact-content text-center">
          <h2 className="mb-4">Contact Us</h2>

          {/* WhatsApp */}
          <div className="contact-item mb-3 ">
            <a
              className="number text-warning"
              href="https://wa.me/+923222999888"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>
                <span className="fab " style={{color:"#25D366"}}>
                <img src={wb} alt=""  className='fab' style={{width:"100px",height:"100px",borderRadius:"50%"}}/>
                </span>
                &nbsp;+92 3 222 999 888
              </h3>
            </a>
          </div>
          <br />
          {/* Email */}
          <div className="contact-item mb-3 ms-5">
            <a
              className="number"
              href="mailto:property92@mail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3 className="text-warning">
                <span className="fab ">
                  <FaEnvelope />
                </span>
                &nbsp;Property92@mail.com
              </h3>
            </a>
          </div>

          {/* Social Media Icons */}
          <br />
          <br />
          <div className="social-icons">
            <a
              href="https://www.facebook.com/www.property92.pk/"
              className="mx-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={fb}className='fab'alt="" style={{width:"100px",height:"100px",borderRadius:"50%"}}/>
            </a>
            <a
              href="https://www.instagram.com/property92.pk/"
              className="mx-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ib} className='fab' alt=""style={{width:"100px",height:"100px",borderRadius:"50%"}}/>
            </a>
            <a
              href="https://www.youtube.com/@property92pk/"
              className="mx-2"
              target="_blank"
              rel="noopener noreferrer"
            >
               <img src={yb} className='fab' alt="" style={{width:"100px",height:"100px",borderRadius:"50%"}}/>
            </a>
          </div>
          <br />

          <div className="container-form  " >
            <div className="row text-center ">
              <div className=" text-center">
                <div className="card shadow-sm p-4">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        First Name:
                      </label>
                      <input
                        type="text"
                        id="name"
                        className="form-control"
                        value={name1}
                        onChange={(e) => setName1(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        Last Name:
                      </label>
                      <input
                        type="text"
                        id="name"
                        className="form-control"
                        value={name2}
                        onChange={(e) => setName2(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="message" className="form-label">
                        Message:
                      </label>
                      <textarea
                        id="message"
                        className="form-control"
                        rows="4"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                      ></textarea>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-success w-100 fw-bold"
                    >
                      Send <span className="fs-4"><FaWhatsapp/></span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
      </section>
     
    </>
  );
};

export default Contact;
